import userApi from "@/apis/UserApi";

const userService = {
  async getSessionUser() {
    return await userApi.getUser();
  },
}

export default userService;